import { Box, Button, ButtonGroup, IconButton } from "@chakra-ui/react";
import PlayIcon from "../../assets/icons/play";
import RefreshOutlined from "../../assets/icons/Refresh";
import { ReactElement, useState } from "react";
import { MdOutlineZoomOutMap } from "react-icons/md";
import AdditionalNote from "../elements/AdditionalNote";

type Iprosp = {
  RunOnClick: () => void;
  isRunning: boolean;
  ResetOnClick: () => void;
  isResetDisabled: boolean;
  CenterElement?: ReactElement;
  crowded?: boolean;
  noReset?: boolean;
  code: string;
  language: string;
  noViewMore?: boolean;
};

const EditorControls = ({
  RunOnClick,
  isRunning,
  ResetOnClick,
  isResetDisabled,
  CenterElement,
  crowded,
  noReset,
  code,
  language,
  noViewMore,
}: Iprosp) => {
  const [open, setOpen] = useState(false);

  return (
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
      p={"1rem"}
      py={{ base: ".5rem", md: "1rem" }}
      bg={"whiteAlpha.100"}
    >
      <Button
        leftIcon={<PlayIcon color={"whiteAlpha.800"} fontSize={"1.5rem"} />}
        onClick={RunOnClick}
        variant={"solid"}
        isLoading={isRunning}
        py={{ base: "1rem", md: "0rem" }}
        loadingText="Running"
        size={{ base: "xs", md: "md" }}
      >
        Run {crowded ? "" : "Code"}
      </Button>

      {CenterElement}

      {crowded ? (
        <ButtonGroup>
          {!noViewMore && (
            <IconButton
              aria-label="reset"
              onClick={() => {
                setOpen(true);
              }}
              variant={"outline"}
              icon={<MdOutlineZoomOutMap />}
              size={{ base: "xs", md: "md" }}
            ></IconButton>
          )}
          <IconButton
            aria-label="reset"
            onClick={ResetOnClick}
            variant={"outline"}
            icon={<RefreshOutlined />}
            size={{ base: "xs", md: "md" }}
          ></IconButton>
        </ButtonGroup>
      ) : !noReset ? (
        <ButtonGroup>
          {!noViewMore && (
            <IconButton
              aria-label="reset"
              onClick={() => {
                setOpen(true);
              }}
              variant={"outline"}
              icon={<MdOutlineZoomOutMap />}
              size={{ base: "xs", md: "md" }}
            ></IconButton>
          )}
          <Button
            leftIcon={<RefreshOutlined />}
            onClick={ResetOnClick}
            variant={"ghost"}
            disabled={isResetDisabled}
            size={{ base: "xs", md: "md" }}
          >
            Reset Code
          </Button>
        </ButtonGroup>
      ) : (
        <></>
      )}
      <Box display={"none"}>
        <AdditionalNote
          open={open}
          title=""
          onClick={() => setOpen(false)}
          explanation={[
            {
              id: 1,
              component: "CodeEditor",
              props: {
                code,
                mode: "view",
                language,
                noScroll: true,
              },
            },
          ]}
        />
      </Box>
    </Box>
  );
};

export default EditorControls;
